import type { ISimpleFilter } from 'hooks/useFilters.hook';

export const scalarFieldsOnlyFilter: ISimpleFilter = {
  key: 'scalarFieldsOnly',
  operator: 'AND',
  value: true,
};
